import React from 'react';
import { SearchIcon, LayersIcon, RocketIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function DifferentiatorSection() {
  const steps = [{
    icon: <SearchIcon className="w-6 h-6 text-turquoise" data-id="element-9" />,
    title: 'Diagnóstico',
    desc: 'Analizamos tu ecosistema digital actual.',
    number: '01'
  }, {
    icon: <LayersIcon className="w-6 h-6 text-turquoise" data-id="element-10" />,
    title: 'Infraestructura',
    desc: 'Construimos activos de alta conversión.',
    number: '02'
  }, {
    icon: <RocketIcon className="w-6 h-6 text-turquoise" data-id="element-11" />,
    title: 'Aceleración',
    desc: 'Impulsamos con tráfico de pago estratégico.',
    number: '03'
  }];
  return <section id="metodologia" className="py-24 bg-petrol relative overflow-hidden" data-id="element-12">
      {/* Tech Background Elements */}
      <div className="absolute top-0 right-0 w-full h-full bg-circuit opacity-20 pointer-events-none" data-id="element-13"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[400px] bg-turquoise/5 rounded-full blur-[100px] pointer-events-none" data-id="element-14"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-15">
        <FadeIn className="text-center mb-20" data-id="element-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-17">
            El éxito no es suerte,{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-turquoise to-turquoise-light" data-id="element-18">
              es estrategia.
            </span>
          </h2>
          <p className="text-xl text-silver max-w-3xl mx-auto leading-relaxed" data-id="element-19">
            Anclamos tu negocio con infraestructura digital sólida y luego lo
            impulsamos con tráfico de pago.
          </p>
        </FadeIn>

        <div className="relative" data-id="element-20">
          {/* Connecting Circuit Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-px bg-petrol-lighter -translate-y-1/2 z-0" data-id="element-21">
            <div className="absolute top-0 left-0 h-full bg-gradient-to-r from-turquoise/0 via-turquoise to-turquoise/0 w-full opacity-50" data-id="element-22"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-23">
            {steps.map((step, idx) => <FadeIn key={idx} delay={idx * 0.2} className="relative group" data-id="element-24">
                {/* Connecting Line (Mobile) */}
                {idx !== steps.length - 1 && <div className="md:hidden absolute left-1/2 bottom-[-3rem] w-px h-12 bg-gradient-to-b from-turquoise/50 to-transparent -translate-x-1/2" data-id="element-25"></div>}

                <div className="bg-petrol-light p-8 rounded-2xl border border-petrol-lighter hover:border-turquoise/30 transition-all duration-300 relative overflow-hidden h-full" data-id="element-26">
                  {/* Tech Accent Corner */}
                  <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-bl from-turquoise/10 to-transparent" data-id="element-27"></div>

                  <div className="flex items-center justify-between mb-8" data-id="element-28">
                    <div className="w-14 h-14 bg-petrol rounded-xl flex items-center justify-center border border-turquoise/20 shadow-[0_0_15px_rgba(0,212,170,0.1)] group-hover:scale-110 transition-transform duration-300" data-id="element-29">
                      {step.icon}
                    </div>
                    <span className="text-4xl font-bold text-petrol-lighter group-hover:text-turquoise/20 transition-colors font-serif" data-id="element-30">
                      {step.number}
                    </span>
                  </div>

                  <h3 className="text-white font-bold text-xl mb-3" data-id="element-31">
                    {step.title}
                  </h3>
                  <p className="text-silver text-base leading-relaxed" data-id="element-32">
                    {step.desc}
                  </p>
                </div>

                {/* Circuit Node Dot (Desktop) */}
                <div className="hidden md:block absolute top-1/2 -left-3 w-6 h-6 bg-petrol border-2 border-turquoise rounded-full -translate-y-1/2 z-20 shadow-[0_0_10px_rgba(0,212,170,0.5)]" data-id="element-33">
                  <div className="absolute inset-1 bg-turquoise rounded-full animate-pulse" data-id="element-34"></div>
                </div>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn delay={0.6} className="mt-20 text-center" data-id="element-35">
          <a href="https://wa.me/50672642898" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 bg-transparent border border-turquoise text-turquoise hover:bg-turquoise hover:text-petrol font-bold rounded transition-all shadow-[0_0_15px_rgba(0,212,170,0.1)] hover:shadow-[0_0_25px_rgba(0,212,170,0.3)]" data-id="element-36">
            Iniciar Diagnóstico
          </a>
        </FadeIn>
      </div>
    </section>;
}